var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip494_108"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "travel-map-location-pin--navigation-map-maps-pin-gps-location--Streamline-Core",
    rx: 0,
    width: 19.333527,
    height: 19.333527,
    transform: "translate(0.333237 0.333237)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "travel-map-location-pin--navigation-map-maps-pin-gps-location--Streamline-Core",
    rx: 0,
    width: 19.333527,
    height: 19.333527,
    transform: "translate(0.333237 0.333237)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip494_108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.57 18.71C9.57 18.71 3.57 10.39 3.57 6.94C3.57 5.29 4.2 3.7 5.33 2.53C6.45 1.36 7.98 0.71 9.57 0.71C11.16 0.71 12.68 1.36 13.81 2.53C14.94 3.7 15.57 5.29 15.57 6.94C15.57 10.39 9.57 18.71 9.57 18.71Z",
    stroke: "#0000AC",
    strokeOpacity: 1,
    strokeWidth: 1.332948,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.57 9.02C8.46 9.02 7.57 8.08 7.57 6.94C7.57 5.79 8.46 4.86 9.57 4.86C10.67 4.86 11.57 5.79 11.57 6.94C11.57 8.08 10.67 9.02 9.57 9.02Z",
    stroke: "#0000AC",
    strokeOpacity: 1,
    strokeWidth: 1.332948,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlue);
export default __webpack_public_path__ + "static/media/location-blue.1283c9b9074ee7d260c77b4a99142e47.svg";
export { ForwardRef as ReactComponent };